<script setup>
import { computed, ref } from 'vue'
import { defaultVTooltipProps } from '@/utils/defaultProps'

const props = defineProps({
  title: { type: String, default: 'Export to file' },
  items: { type: Array, default: () => [] },
  iconName: { type: String, default: 'mdi-download-circle-outline' },
  disabled: { type: Boolean, default: false },
  showLabel: { type: Boolean, default: false },
  vBtnProps: { type: Object, default: () => ({}) },
  label: { type: String, default: null },
  loading: { type: Boolean, default: false },
})

const visibleItems = computed(() => props.items.filter((item) => item && (item.show === undefined || item.show)))

const baseId = ref(`export-menu-${Math.random().toString(36).slice(2, 8)}`)

const onItemClick = (item) => {
  if (typeof item?.onClick === 'function') {
    item.onClick()
  }
}

const btnProps = computed(() => ({
  ...props.vBtnProps,
  'aria-label': props.title,
  'disabled': props.disabled || visibleItems.value.length === 0,
}))
</script>

<template>
  <v-menu
    offset-y
    transition="scale-transition"
  >
    <template #activator="{ attrs: menuAttrs, on: menuOn }">
      <v-tooltip
        v-bind="defaultVTooltipProps"
        open-on-hover
        top
      >
        <template #activator="{ attrs: tooltipAttrs, on: tooltipOn }">
          <v-btn
            v-bind="{ ...menuAttrs, ...tooltipAttrs, ...btnProps }"
            v-on="{ ...menuOn, ...tooltipOn }"
            :loading="loading"
            class="flat-button border"
          >
            <v-icon :class="{ 'mr-1': showLabel }">{{ iconName }}</v-icon>
            <span v-if="showLabel">{{ label || title }}</span>
          </v-btn>
        </template>

        <span>{{ title }}</span>
      </v-tooltip>
    </template>

    <v-list>
      <v-list-item
        v-for="(item, index) in visibleItems"
        :id="`${baseId}-${index}`"
        :key="`${item.title || 'item'}-${index}`"
        :disabled="!!item.disabled"
        @click="onItemClick(item)"
      >
        <v-list-item-icon v-if="item.icon">
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>

        <v-tooltip
          v-if="item.description"
          :activator="`#${baseId}-${index}`"
          v-bind="defaultVTooltipProps"
          max-height="10rem"
          left
        >
          <span v-html="item.description" />
        </v-tooltip>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
